import React from 'react';
import { Controller, ControllerProps } from 'react-hook-form';
import {
    Slider, SliderProps,
} from '@mui/material';

export interface SliderControlProps extends
	Omit<ControllerProps<any, any>, 'defaultValue' | 'name' | 'render'>,
	SliderProps {}

export const SliderControl: React.FC<SliderControlProps> = props => {
    const {
        control,
        defaultValue,
        name,
        rules,
        shouldUnregister,
        value,
        ...sliderProps
    } = props;
    return (
        <Controller
            control={control}
            defaultValue={defaultValue}
            name={name}
            render={(renderProps): JSX.Element => {
                const { field, formState } = renderProps;
                return (
                    <Slider
                        {...sliderProps}
                        name={field.name}
                        value={value || field.value || 0}
                        onBlur={(e): void => {
                            sliderProps.onBlur?.(e);
                            field.onBlur();
                        }}
                        onChange={(e, value, aciveThumb): void => {
                            sliderProps.onChange?.(e, value, aciveThumb);
                            field.onChange({
                                ...e,
                                target: { ...e.target, value }
                            });
                        }}
                    />
                );
            }}
            rules={rules}
            shouldUnregister={shouldUnregister} />
    );
};
